import { render, staticRenderFns } from "./AddChecklistItem.vue?vue&type=template&id=f06f27a8&scoped=true&"
import script from "./AddChecklistItem.vue?vue&type=script&lang=js&"
export * from "./AddChecklistItem.vue?vue&type=script&lang=js&"
import style0 from "./AddChecklistItem.vue?vue&type=style&index=0&id=f06f27a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06f27a8",
  null
  
)

export default component.exports